import React, { Component } from 'react';
import {
  Card,
  CardContent,
  CardActions,
  IconButton,
  Grid
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import UpdateIcon from '@material-ui/icons/Update';
import styled from 'styled-components';
import { inject } from 'mobx-react';

const CardContainer = styled.div`
  margin-bottom: 20px;
`;

const CardToEmail = styled.h3`
margin: 8px 0;
font-size: 22px;
`;

const CardToName = styled.h3`
margin: 8px 0;
font-size: 22px;
`;

@inject('notesStore')
class Note extends Component {
  deleteNote = () => {
    this.props.notesStore.deleteNote(this.props.uuid);
  };

  handleUpdateClick = () => {
    const { uuid, toEmail, toName, body } = this.props;
    const queryParams = new URLSearchParams({
      uuid,
      toEmail,
      toName,
      body
    }).toString();
    window.location.hash = `/notes/update?${queryParams}`;
  };

  render() {
    const { toEmail, toName, body } = this.props;

    return (
      <CardContainer>
        <Card>
          <CardContent>
            <CardToEmail>{toEmail}</CardToEmail>
            <CardToName>{toName}</CardToName>
            {body}
          </CardContent>
          <CardActions style={{ padding: '14px' }} disableSpacing>
            <Grid
              justify="space-between" // Add it here :)
              container 
            >
              <Grid item>
                <IconButton onClick={this.deleteNote}>
                  <DeleteIcon color="error" />
                </IconButton>
              </Grid>
              <Grid item>
                <IconButton onClick={this.handleUpdateClick}>
                  <UpdateIcon color="error" />
                </IconButton>
              </Grid>
            </Grid>
          </CardActions>
        </Card>
      </CardContainer>
    );
  }
}

export default Note;
